import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {selectedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {selectPresentationToEditAction} from '../../store/actions/presentation';

export default function usePresentationToEdit(presentationId: string | undefined): void {
    const presentation = useSelector(selectedPresentationSelector);

    const dispatch = useDispatch();
    const {_id, found} = presentation;
    const navigate = useNavigate();

    useEffect(() => {
        if (_id !== presentationId) {
            if (found === false) {
                navigate('/');
            } else {
                dispatch(selectPresentationToEditAction(presentationId || '', navigate));
            }
        }
    }, [_id, dispatch, found, navigate, presentation.slideIndexList, presentationId]);
}
